import { jwtDecode } from 'jwt-decode';
import { setAuthToken } from '../services/api';
import { clearAllRiderOfflineData } from './indexedDB';
import { syncRiderServiceWorker } from './riderOffline';

let logoutTimerId = null;
let sessionWatchStarted = false;
let forcedLogoutInProgress = false;

export const getTokenExpiryMs = (token = localStorage.getItem('token')) => {
  if (!token) {
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    if (!decoded?.exp) {
      return null;
    }
    return decoded.exp * 1000;
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token = localStorage.getItem('token')) => {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) {
    return !token;
  }
  return Date.now() >= expiryMs;
};

export const clearSessionLogoutTimer = () => {
  if (logoutTimerId) {
    window.clearTimeout(logoutTimerId);
    logoutTimerId = null;
  }
};

export const forceLogout = async (reason = 'expired') => {
  if (forcedLogoutInProgress) {
    return;
  }

  if (!localStorage.getItem('token') && !localStorage.getItem('userRole')) {
    return;
  }

  forcedLogoutInProgress = true;
  clearSessionLogoutTimer();

  const role = localStorage.getItem('userRole');
  if (role === 'rider') {
    try {
      await clearAllRiderOfflineData();
    } catch (error) {
      // ignore
    }
  }

  setAuthToken(null);
  localStorage.clear();
  syncRiderServiceWorker(null);

  const loginUrl = reason === 'expired'
    ? '/login?reason=session_expired'
    : '/login';

  if (window.location.pathname !== '/login') {
    window.location.assign(loginUrl);
  } else {
    forcedLogoutInProgress = false;
  }
};

export const scheduleSessionExpiryLogout = () => {
  clearSessionLogoutTimer();

  const token = localStorage.getItem('token');
  if (!token) {
    return;
  }

  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) {
    forceLogout('expired');
    return;
  }

  const remainingMs = expiryMs - Date.now();
  if (remainingMs <= 0) {
    forceLogout('expired');
    return;
  }

  logoutTimerId = window.setTimeout(() => {
    forceLogout('expired');
  }, remainingMs);
};

export const startSessionWatch = () => {
  if (sessionWatchStarted) {
    scheduleSessionExpiryLogout();
    return;
  }

  sessionWatchStarted = true;
  scheduleSessionExpiryLogout();

  // Catch idle tabs that may have missed the timeout (browser throttling)
  window.setInterval(() => {
    if (isTokenExpired()) {
      forceLogout('expired');
    }
  }, 15000);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && isTokenExpired()) {
      forceLogout('expired');
    } else {
      scheduleSessionExpiryLogout();
    }
  });

  window.addEventListener('focus', () => {
    if (isTokenExpired()) {
      forceLogout('expired');
    }
  });
};
